function Servicios() {
  return <div>Servicios</div>;
}

export default Servicios;
